<template>
	<div class="commodity page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<el-dialog title="藏品信息" :visible="dialogVisible" @close="dialogVisible = false">
			<ul class="commodity-info">
				<li><span class="key">藏品名称：</span><span class="value">{{info.lotName}}</span></li>
				<li><span class="key">藏品图片：</span><span class="value">
						<img :src="$pub.imageUrl+info.lotPictrueUrl" alt=""></span></li>
				<li><span class="key">文件大小：</span><span class="value">{{info.lotPictrueSize}}KB</span></li>
				<li><span class="key">创作完成时间：</span><span class="value">{{info.finishTime}}</span></li>
				<li><span class="key">藏品作者（发行方）：</span><span class="value">{{info.lotAuthor}}</span></li>
				<li><span class="key">藏品类别：</span><span class="value">{{info.lotOneTypeName}},{{info.lotTwoTypeName}}</span></li>
				<li><span class="key">藏品标签：</span><span class="value">{{info.lotLabel}}</span></li>
				<li><span class="key">藏品介绍：</span><span class="value" v-html="info.lotDescribe"></span></li>
				<li><span class="key">上链渠道：</span><span class="value">{{info.cochainChannel==='1'?'百度':'中经天平'}}</span>
				</li>
				<li><span class="key">区块链地址：</span><span class="value">{{info.blockchainAddress}}</span></li>
				<li><span class="key">藏品创建时间：</span><span class="value">{{info.createAt}}</span></li>
			</ul>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'commodity',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加商品',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'lotName',
							label: '商品名称',
							width: 300
						},
						{
							prop: 'lotAuthor',
							label: '作者',
							width: 100
						},
						{
							prop: 'blockchainAddress',
							label: '区块链地址',
							width: 300
						},
						{
							prop: 'lotPictrueSize',
							label: '文件大小（KB）',
							width: 200
						},
						{
							prop: 'createAt',
							label: '创建时间',
							width: 240
						},
						{
							prop: 'lotLabel',
							label: '标签',
							width: 300
						}
					],
					tableEvent: [{
						icon: 'el-icon-search',
						name: '查看',
						color: 'blue',
						sign: 'check'
					}],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				dialogVisible: false,
				info: {}
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData()
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/compile'
					})
				}
			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign == 'check') {
					this.info = row
					this.dialogVisible = true
				}
				// if (sign == 'delete') {
				// 	this.deleteCommodity(row)
				// }
			},
			// 删除商品
			deleteCommodity(row) {

			},
			recordPageChange(e) {
				this.recordConfig.currentPage = e
			},
			fetchData() {
				this.$api.commodityList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.tableData = res.data.list
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.dialog-pager {
		width: 100%;
		height: 70px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.commodity-info{
		width: 100%;
		li{
			width: 100%;
			line-height: 40px;
			display: flex;
			align-items: flex-start;
			font-size: @vue-font-size-sm;
			.key{
				color: @vue-text-color-active;
				white-space: nowrap;
				padding-right: @vue-spacing-row-sm;
			}
			img{
				width: 94%;
				display: block;
			}
		}
	}
</style>
